<template>
  <div id="app">
    <notifications></notifications>
    <router-view/>
  </div>
</template>


<script>
    export default {

        mounted: function () {
            if (screen.width < 700) {
                this.$root.mobile = true;
            }
        },
    };
</script>